import createIcon from '@/lib/create-icon'

const PoliticsIcon = createIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 47 46'
    fill='none'
  >
    <path
      fill='none'
      d='M7.53052 23.8643L11.3637 33.3681'
      stroke='url(#paint0_linear_5317_718)'
      strokeWidth='2.56194'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M7.53052 23.8643L11.3637 33.3681'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.56194'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M7.53052 23.8643L11.3637 33.3681'
      stroke='url(#paint1_radial_5317_718)'
      strokeOpacity='0.6'
      strokeWidth='2.56194'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M7.53023 23.8639L5.94626 24.5028C4.47019 25.0981 3.73215 25.3958 3.24722 25.8717C2.60068 26.5064 2.23271 27.3718 2.22424 28.2777C2.21794 28.9572 2.51559 29.6952 3.11095 31.1713C3.70631 32.6474 4.00396 33.3854 4.47995 33.8704C5.11453 34.5168 5.98002 34.8849 6.88594 34.8934C7.56536 34.8996 8.3034 34.6019 9.77947 34.0066L11.3634 33.3677L25.7099 32.0453C27.3958 31.8898 28.2389 31.8122 29.0669 31.939L29.1066 31.9453C29.934 32.0772 30.7129 32.4083 32.2711 33.0708L32.6448 33.2297C32.9099 33.3425 33.0424 33.3988 33.1778 33.4318C33.4334 33.4941 33.7 33.4967 33.9567 33.4391C34.0924 33.4086 34.2261 33.3547 34.4933 33.2469C35.104 33.0006 35.4094 32.8775 35.6221 32.695C36.0271 32.3478 36.2465 31.8317 36.2156 31.2992C36.1994 31.0194 36.0762 30.714 35.8299 30.1034L27.415 9.23994C27.1687 8.62924 27.0455 8.3239 26.863 8.11113C26.5159 7.70624 25.9997 7.48668 25.4673 7.51764C25.1875 7.53391 24.8821 7.65708 24.2714 7.90336C24.0042 8.01114 23.8705 8.06506 23.7516 8.13733C23.5268 8.27396 23.3365 8.46068 23.1958 8.68291C23.1211 8.80058 23.0648 8.93314 22.9521 9.19833L22.7932 9.57197C22.1307 11.1301 21.7996 11.9091 21.2951 12.5781L21.2709 12.6101C20.7626 13.276 20.1015 13.8049 18.7795 14.8627L7.53023 23.8639Z'
      stroke='url(#paint2_linear_5317_718)'
      strokeWidth='2.56194'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M7.53023 23.8639L5.94626 24.5028C4.47019 25.0981 3.73215 25.3958 3.24722 25.8717C2.60068 26.5064 2.23271 27.3718 2.22424 28.2777C2.21794 28.9572 2.51559 29.6952 3.11095 31.1713C3.70631 32.6474 4.00396 33.3854 4.47995 33.8704C5.11453 34.5168 5.98002 34.8849 6.88594 34.8934C7.56536 34.8996 8.3034 34.6019 9.77947 34.0066L11.3634 33.3677L25.7099 32.0453C27.3958 31.8898 28.2389 31.8122 29.0669 31.939L29.1066 31.9453C29.934 32.0772 30.7129 32.4083 32.2711 33.0708L32.6448 33.2297C32.9099 33.3425 33.0424 33.3988 33.1778 33.4318C33.4334 33.4941 33.7 33.4967 33.9567 33.4391C34.0924 33.4086 34.2261 33.3547 34.4933 33.2469C35.104 33.0006 35.4094 32.8775 35.6221 32.695C36.0271 32.3478 36.2465 31.8317 36.2156 31.2992C36.1994 31.0194 36.0762 30.714 35.8299 30.1034L27.415 9.23994C27.1687 8.62924 27.0455 8.3239 26.863 8.11113C26.5159 7.70624 25.9997 7.48668 25.4673 7.51764C25.1875 7.53391 24.8821 7.65708 24.2714 7.90336C24.0042 8.01114 23.8705 8.06506 23.7516 8.13733C23.5268 8.27396 23.3365 8.46068 23.1958 8.68291C23.1211 8.80058 23.0648 8.93314 22.9521 9.19833L22.7932 9.57197C22.1307 11.1301 21.7996 11.9091 21.2951 12.5781L21.2709 12.6101C20.7626 13.276 20.1015 13.8049 18.7795 14.8627L7.53023 23.8639Z'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.56194'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M7.53023 23.8639L5.94626 24.5028C4.47019 25.0981 3.73215 25.3958 3.24722 25.8717C2.60068 26.5064 2.23271 27.3718 2.22424 28.2777C2.21794 28.9572 2.51559 29.6952 3.11095 31.1713C3.70631 32.6474 4.00396 33.3854 4.47995 33.8704C5.11453 34.5168 5.98002 34.8849 6.88594 34.8934C7.56536 34.8996 8.3034 34.6019 9.77947 34.0066L11.3634 33.3677L25.7099 32.0453C27.3958 31.8898 28.2389 31.8122 29.0669 31.939L29.1066 31.9453C29.934 32.0772 30.7129 32.4083 32.2711 33.0708L32.6448 33.2297C32.9099 33.3425 33.0424 33.3988 33.1778 33.4318C33.4334 33.4941 33.7 33.4967 33.9567 33.4391C34.0924 33.4086 34.2261 33.3547 34.4933 33.2469C35.104 33.0006 35.4094 32.8775 35.6221 32.695C36.0271 32.3478 36.2465 31.8317 36.2156 31.2992C36.1994 31.0194 36.0762 30.714 35.8299 30.1034L27.415 9.23994C27.1687 8.62924 27.0455 8.3239 26.863 8.11113C26.5159 7.70624 25.9997 7.48668 25.4673 7.51764C25.1875 7.53391 24.8821 7.65708 24.2714 7.90336C24.0042 8.01114 23.8705 8.06506 23.7516 8.13733C23.5268 8.27396 23.3365 8.46068 23.1958 8.68291C23.1211 8.80058 23.0648 8.93314 22.9521 9.19833L22.7932 9.57197C22.1307 11.1301 21.7996 11.9091 21.2951 12.5781L21.2709 12.6101C20.7626 13.276 20.1015 13.8049 18.7795 14.8627L7.53023 23.8639Z'
      stroke='url(#paint3_radial_5317_718)'
      strokeOpacity='0.6'
      strokeWidth='2.56194'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M13.2671 33.5215L14.8935 37.554C15.5831 39.2635 17.5278 40.0904 19.2373 39.4009C20.2722 38.9835 21.0302 38.0765 21.2568 36.9838L22.1453 32.7031'
      stroke='url(#paint4_linear_5317_718)'
      strokeWidth='2.56194'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M13.2671 33.5215L14.8935 37.554C15.5831 39.2635 17.5278 40.0904 19.2373 39.4009C20.2722 38.9835 21.0302 38.0765 21.2568 36.9838L22.1453 32.7031'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.56194'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M13.2671 33.5215L14.8935 37.554C15.5831 39.2635 17.5278 40.0904 19.2373 39.4009C20.2722 38.9835 21.0302 38.0765 21.2568 36.9838L22.1453 32.7031'
      stroke='url(#paint5_radial_5317_718)'
      strokeOpacity='0.6'
      strokeWidth='2.56194'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M40 23L46 22'
      stroke='url(#paint6_linear_5317_718)'
      strokeWidth='2'
      strokeLinecap='round'
    />
    <path
      fill='none'
      d='M40 23L46 22'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2'
      strokeLinecap='round'
    />
    <path
      fill='none'
      d='M40 23L46 22'
      stroke='url(#paint7_radial_5317_718)'
      strokeOpacity='0.6'
      strokeWidth='2'
      strokeLinecap='round'
    />
    <path
      fill='none'
      d='M35 10.5L40 6'
      stroke='url(#paint8_linear_5317_718)'
      strokeWidth='2'
      strokeLinecap='round'
    />
    <path
      fill='none'
      d='M35 10.5L40 6'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2'
      strokeLinecap='round'
    />
    <path
      fill='none'
      d='M35 10.5L40 6'
      stroke='url(#paint9_radial_5317_718)'
      strokeOpacity='0.6'
      strokeWidth='2'
      strokeLinecap='round'
    />
    <path
      fill='none'
      d='M36.5 17.5L46 12.5'
      stroke='url(#paint10_linear_5317_718)'
      strokeWidth='2'
      strokeLinecap='round'
    />
    <path
      fill='none'
      d='M36.5 17.5L46 12.5'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2'
      strokeLinecap='round'
    />
    <path
      fill='none'
      d='M36.5 17.5L46 12.5'
      stroke='url(#paint11_radial_5317_718)'
      strokeOpacity='0.6'
      strokeWidth='2'
      strokeLinecap='round'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5317_718'
        x1='7.53052'
        y1='23.8643'
        x2='9.13753'
        y2='23.3393'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_5317_718'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(11.8274 33.1811) rotate(-21.9659) scale(0.5 5.21853)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint2_linear_5317_718'
        x1='-2'
        y1='18.4995'
        x2='37.4536'
        y2='29.8372'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint3_radial_5317_718'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(22.4776 38.0932) rotate(-21.9659) scale(15.3716 13.9161)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint4_linear_5317_718'
        x1='13.2671'
        y1='33.5215'
        x2='24.2966'
        y2='36.6193'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint5_radial_5317_718'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(20.1019 39.0522) rotate(-21.9659) scale(4.2699 3.9139)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint6_linear_5317_718'
        x1='40'
        y1='22'
        x2='40.5537'
        y2='24.3071'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint7_radial_5317_718'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(43 23) scale(3 0.509237)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint8_linear_5317_718'
        x1='35'
        y1='6'
        x2='40.3105'
        y2='10.0976'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint9_radial_5317_718'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(37.5 10.5) scale(2.5 2.29157)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint10_linear_5317_718'
        x1='36.5'
        y1='12.5'
        x2='42.3729'
        y2='20.249'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint11_radial_5317_718'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(41.25 17.5) scale(4.75 2.54619)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
    </defs>
  </svg>,
  'PoliticsIcon'
)

export default PoliticsIcon
